import { create } from 'zustand';

import { ReferralSourceImport } from 'services/api/admin/referralSourceImports';

// Uploads still being processed. Kept here rather than in the page that started them, so the
// result notification (and its skipped-rows download) still arrives after the admin leaves the page.
type ReferralSourceImportStore = {
  trackedImports: ReferralSourceImport[];
  trackImport: (referralSourceImport: ReferralSourceImport) => void;
  untrackImport: (importId: string) => void;
};

export const useReferralSourceImportStore = create<ReferralSourceImportStore>((set) => ({
  trackedImports: [],
  trackImport: (referralSourceImport) =>
    set((state) => ({ trackedImports: [...state.trackedImports, referralSourceImport] })),
  untrackImport: (importId) =>
    set((state) => ({ trackedImports: state.trackedImports.filter((tracked) => tracked.id !== importId) })),
}));
